import { NotificationData, ResponseError } from '@vcd-ecm-ui/Common';
import { GridDataNativeType, GridFilter, GridSort } from '../Interfaces';

export const DATA_REQUEST_SERVICE_STARTED = 'DataRequestStarted';
export const DATA_REQUEST_SERVICE_SUCCEEDED = 'DataRequestSucceeded';
export const DATA_REQUEST_SERVICE_FAILED = 'DataRequestFailed';
export const DATA_REQUEST_CACHE = 'DataRequestCache';
export const SET_NOTIFICATION = 'setNotification';
export const CLEAR_NOTIFICATION = 'clearNotification';
export const SET_FILTERS_SORTERS = 'setFiltersSorters';
export const CLEAR_FILTERS_SORTERS = 'clearFiltersSorters';
export const SET_PAGINATION_FILTERS_SORTERS = 'setPaginationFiltersSorters';
export const ADD_FILTER = 'addFilter';
export const DELETE_FILTER = 'deleteFilter';
export const SET_FILTERS_SORTERS_READY = 'setFiltersSortersReady';

export interface DataRequestStartedAction {
  type: typeof DATA_REQUEST_SERVICE_STARTED;
}

export interface DataRequestSucceededAction {
  type: typeof DATA_REQUEST_SERVICE_SUCCEEDED;
  dataRows: GridDataNativeType[];
  pageNumber: number;
  pageSize: number;
  totalNumberRows: number;
  startRow: number;
  endRow: number;
  cacheStartRow: number;
  cacheEndRow: number;
  filters: GridFilter[];
  sorters: GridSort[];
}

export interface DataRequestCacheAction {
  type: typeof DATA_REQUEST_CACHE;
  pageNumber: number;
  pageSize: number;
  startRow: number;
  endRow: number;
}

export interface DataRequestFailedAction {
  type: typeof DATA_REQUEST_SERVICE_FAILED;
  error: ResponseError;
}

export interface SetNotificationAction {
  type: typeof SET_NOTIFICATION;
  notification: NotificationData;
}

export interface ClearNotificationAction {
  type: typeof CLEAR_NOTIFICATION;
}

export interface SetFiltersSortersAction {
  type: typeof SET_FILTERS_SORTERS;
  filters: GridFilter[];
  sorters: GridSort[];
}

export interface SetPaginationFiltersSortersAction {
  type: typeof SET_PAGINATION_FILTERS_SORTERS;
  pageNumber: number;
  pageSize: number;
  filters: GridFilter[];
  sorters: GridSort[];
}

export interface AddFilterAction {
  type: typeof ADD_FILTER;
  filter: GridFilter;
}

export interface DeleteFilterAction {
  type: typeof DELETE_FILTER;
  filter: GridFilter;
}

export interface ClearFiltersSortersAction {
  type: typeof CLEAR_FILTERS_SORTERS;
}

export interface SetFiltersSortersReadyAction {
  type: typeof SET_FILTERS_SORTERS_READY;
}

export type ReportActionTypes = DataRequestSucceededAction
  | DataRequestStartedAction
  | DataRequestFailedAction
  | DataRequestCacheAction
  | SetNotificationAction
  | ClearNotificationAction
  | SetFiltersSortersAction
  | ClearFiltersSortersAction
  | SetPaginationFiltersSortersAction
  | AddFilterAction
  | DeleteFilterAction
  | SetFiltersSortersReadyAction
